tiz.directive('maskedPhoneInput', function() {
  return {
    restrict: 'E',
    replace: true,
    template: '<input type="tel" mask="(999) 999-9999" clean="true" restrict="reject">',
    require: 'ngModel',
    link: function(scope, element, attrs, modelCtrl) {
      modelCtrl.$formatters.push(function(value) {
        if (!value) { return ''; }
        var newValue = value.replace(/\D/g, '').replace(/^1/, '').slice(0, 10);
        if (newValue != value) {
          modelCtrl.$setViewValue(newValue);
          modelCtrl.$render();
        }
        return newValue;
      });
    }
  };
});
